export { default } from './CarrosEletricosHeroMesAmbiente';
